import { render, staticRenderFns } from "./DbStatus.vue?vue&type=template&id=350cdc21&scoped=true"
import script from "./DbStatus.vue?vue&type=script&lang=js"
export * from "./DbStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350cdc21",
  null
  
)

export default component.exports